
//The auth reducer
export const authReducer = (state=[] , action) =>{            
    switch (action.type) {
        case 'AUTH':                //google auth
            localStorage.setItem('profile',JSON.stringify(action.payload)) ;  //store google auth in localStorage
            return action.payload ;                  
        case 'SIGNIN':                      
            localStorage.setItem('profile',JSON.stringify(action.payload)) ;  //store auth data in localStorage
            return action.payload ; 
        case 'SIGNUP':               
            localStorage.setItem('profile',JSON.stringify(action.payload)) ;  //store auth data in localStorage
            return action.payload ;            
        case 'LOGOUT':
            localStorage.clear();                    //clear the auth data from the localStorage
            return state ;             
        default:
            return state ;
    }
};